/***
 * Type safe way to assert the name of a field and return that value as a string
 *
 * usage:
 *  type Device = {
 *    connected?: boolean
 *  }
 *  nameof<Device>("connected") //compiles, returns "connected"
 *  nameof<Device>("connecteD") //Compile Errors
 *  nameof("connected", device) //compiles, checks without generic
 *  nameof("connecteD", device) //Compile Errors
 * @param name
 */
export const nameof = <T>(name: keyof T, instance?: T): keyof T => name;

export type NonNullableRequired<T> = NonNullable<
  {
    [P in keyof Required<T>]: NonNullableRequired<NonNullable<T[P]>>;
  }
>;

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

export type PartialExcept<T, K extends keyof T> = RecursivePartial<T> &
  Pick<T, K>;

/**
 * used with enums to get the "values"
 * Similar to "keyof typeof Enum", but gets the various possible VALUES of the Enum.
 */
export type ValueOf<T> = T[keyof T];
